import { useEffect, useState } from "react";
import {
  cancelarTramite,
  iniciarTramite,
  listarTiposTramite,
  listarTramites,
} from "../api/Tramite";
import { useEstablecimiento } from "../context/Establecimiento";
import { useAuthentication } from "../context/Authentication";
import { useCatalog } from "../context/Catalog";
import { useTranslation } from "react-i18next";
import "./css/usuario.css";
import {
  ACCIONES_TRAMITE,
  listarAcciones,
  ordenarTiposTramite,
} from "../utils/tramite";
import { useNavigate } from "react-router-dom";
import { useDialog } from "../components/controls/Dialog";
import Loader from "../components/controls/Loader";
import Grid from "../components/layout/Grid";
import Row from "../components/layout/Row";
import Col from "../components/layout/Col";
import DocumentoIcon from "../components/icon/DocumentoIcon";
import Label from "../components/controls/Label";
import TramiteIcon from "../components/icon/TramiteIcon";
import EmpresaEIndustriaIcon from "../components/icon/EmpresaEIndustriaIcon";
import CertificadoAmbienteIcon from "../components/icon/CertificadoAmbienteIcon";
import AguaIcon from "../components/icon/AguaIcon";
import AireIcon from "../components/icon/AireIcon";
import ReciclajeBasuraIcon from "../components/icon/ReciclajeBasuraIcon";
import Alert from "../components/controls/Alert";
import LinkButton from "../components/controls/LinkButton";
import { ESTABLECIMIENTOS_ENDPOINT } from "../utils/api";
import FilesIcon from "../components/icon/FilesIcon";
import DownloadIcon from "../components/icon/DownloadIcon";
import { EstadoTramite, TipoTramite } from "../utils/enums";

const ICONOS = {
  DJE: <TramiteIcon scale={"3x"} className="text-primary" />,
  DJG: <CertificadoAmbienteIcon scale={"3x"} className="text-primary" />,
  DJA: <EmpresaEIndustriaIcon scale={"3x"} className="text-primary" />,
  DJEELL: <AguaIcon scale={"3x"} className="text-primary" />,
  DJEEGG: <AireIcon scale={"3x"} className="text-primary" />,
  DJRR: <ReciclajeBasuraIcon scale={"3x"} className="text-primary" />,
};

export default function HomePage({ ...props }) {
  const { token } = useAuthentication();
  const { establecimiento } = useEstablecimiento();
  const tiposCatalog = useCatalog(
    [
      "tiposTramite",
      "home",
      TipoTramite.DJE,
      TipoTramite.DJG,
      TipoTramite.DJA,
      TipoTramite.DJRR,
      TipoTramite.DJEELL,
      TipoTramite.DJEEGG,
    ],
    () =>
      listarTiposTramite({
        codigo: [
          TipoTramite.DJE,
          TipoTramite.DJG,
          TipoTramite.DJA,
          TipoTramite.DJRR,
          TipoTramite.DJEELL,
          TipoTramite.DJEEGG,
        ],
      }),
  );
  const [actualizar, setActualizar] = useState(true);
  const [tiposTramites, setTiposTramites] = useState([]);
  const [tramitesPorTipo, setTramitesPorTipo] = useState({});
  const [accionesPorTipo, setAccionesPorTipo] = useState({});
  const [loading, setLoading] = useState(true);
  const [executing, setExecuting] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const dialog = useDialog({ showing: false, variant: "warning" });
  const handleMiEstadoClick = (action, numero, tipo) => (event) => {};
  const handleMisTramitesClick = (event) => {
    event.preventDefault();
    navigate("/reportes/tramites");
  };
  const handleAccionClick = (action, numero, tipo) => (event) => {
    // TODO: manejar evento
    event.preventDefault();
    setExecuting(true);
    switch (action) {
      case ACCIONES_TRAMITE.crear:
        iniciarTramite(
          tipo.codigo,
          establecimiento.CUIT,
          establecimiento.CURT,
          token,
        ).then((tramite) => {
          navigate(`tramite/${tramite.numero}`);
        });
        break;
      case ACCIONES_TRAMITE.editar:
        navigate(`tramite/${numero}`);
        break;
      case ACCIONES_TRAMITE.eliminar:
        dialog.display(
          t("messages.establecimiento.eliminarTramite.title"),
          <p>{t("messages.establecimiento.eliminarTramite.value")}</p>,
          t("usuarioPage.accept"),
          t("usuarioPage.decline"),
          () => {
            const localSetLoading = setLoading;
            const localSetActualizar = setActualizar;
            localSetLoading(true);
            cancelarTramite(numero, token)
              .then(() => {
                localSetLoading(false);
                localSetActualizar(true);
              })
              .finally(() => {
                dialog.close();
              });
          },
          () => {
            dialog.close();
          },
        );
        break;
      case ACCIONES_TRAMITE.ver:
        navigate(`tramite/${numero}`);
        break;
      default:
        console.error("Acción no disponible");
    }
    setExecuting(false);
  };
  useEffect(() => {
    if (!actualizar || establecimiento === null) return;
    if (!tiposCatalog.data) return;
    setLoading(true);
    const tipos = tiposCatalog.data;
    listarTramites(
      {
        tipos: tipos.map((tipo) => tipo.codigo),
        CURT: establecimiento.CURT,
        estados: [
          EstadoTramite.PENDIENTE,
          EstadoTramite.INICIADO,
          EstadoTramite.FINALIZADO,
          EstadoTramite.PRESENTADO,
          EstadoTramite.APROBADO,
        ],
      },
      token,
    ).then(({ tramites }) => {
      const tramitesPorTipo = {};
      const accionesPorTipo = {};
      tipos.forEach((tipo) => {
        const filtrados = tramites
          .filter((tramite) => tramite.tipo.codigo === tipo.codigo)
          .sort((tramiteA, tramiteB) => {
            if (!tramiteA.fechaEstado && !!tramiteB.fechaEstado) return -1;
            if (!tramiteB.fechaEstado && !!tramiteA.fechaEstado) return 1;
            if (!tramiteB.fechaEstado && !tramiteB.fechaEstado) return 0;
            const fechaEstadoA = Date.parse(tramiteA.fechaEstado);
            const fechaEstadoB = Date.parse(tramiteB.fechaEstado);
            if (fechaEstadoA > fechaEstadoB) return 1;
            if (fechaEstadoA < fechaEstadoB) return -1;
            return 0;
          });

        const ultimoTramite =
          (filtrados.length > 0 && filtrados.pop()) || undefined;
        tramitesPorTipo[tipo.codigo] = ultimoTramite;
      });
      tipos.forEach((tipo) => {
        const acciones = listarAcciones(
          tipo,
          establecimiento,
          tramitesPorTipo[tipo.codigo],
          tramitesPorTipo,
        );
        accionesPorTipo[tipo.codigo] = acciones;
      });
      setTiposTramites(tipos);
      setTramitesPorTipo(tramitesPorTipo);
      setAccionesPorTipo(accionesPorTipo);
      setActualizar(false);
      setLoading(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actualizar, establecimiento, token, tiposCatalog.data]);
  const loadingState = loading || tiposCatalog.loading;
  return (
    <Loader loading={loadingState && !establecimiento}>
      {dialog.component}
      <Grid id="homePage" className="usuario-page" style={{ height: "100%" }}>
        <Row style={{ display: "flex", flexWrap: "wrap", height: "100%" }}>
          <Col lg={6} style={{ paddingLeft: "24px", paddingRight: "24px" }}>
            <h2>{t("usuarioPage.miEstado")}</h2>
            <Grid style={{ paddingLeft: "10%", paddingRight: "10%" }}>
              <Row>
                <Col>
                  {establecimiento.estaEmpadronado && (
                    <DocumentoIcon
                      scale={"5x"}
                      className="text-primary"
                      style={{ minHeight: "400px" }}
                    />
                  )}
                  {!establecimiento.estaEmpadronado && (
                    <DocumentoIcon
                      scale={"5x"}
                      className="text-muted"
                      style={{ minHeight: "400px" }}
                    />
                  )}
                </Col>
              </Row>
              <Row>
                <Col style={{ height: "15ex" }}>
                  <p className="text-muted" style={{ textAlign: "justify" }}>
                    {t("usuarioPage.mensajes.miEstado")}
                  </p>
                </Col>
              </Row>
              <Row>
                <Col>
                  <p>
                    <LinkButton
                      href={`${ESTABLECIMIENTOS_ENDPOINT}/${establecimiento.CURT}.pdf?token=${token}`}
                      download={`${establecimiento.CURT}.pdf`}
                      variant="primary"
                      onClick={handleMiEstadoClick}
                      value={t(`usuarioPage.acciones.descargar`)}
                      iconBefore={<DownloadIcon />}
                      disabled={executing || !establecimiento.estaEmpadronado}
                    />
                    <LinkButton
                      variant="default"
                      onClick={handleMisTramitesClick}
                      value={t(`usuarioPage.acciones.misTramites`)}
                      iconBefore={<FilesIcon />}
                      disabled={executing || !establecimiento.estaEmpadronado}
                    />
                  </p>
                </Col>
              </Row>
            </Grid>
          </Col>
          <Col lg={6}>
            <h2>{t("usuarioPage.misTramites")}</h2>
            <Grid>
              <Row>
                <Col>
                  <Alert variant="warning">
                    <p style={{ fontSize: "16pt" }} className="text-muted">
                      {t("usuarioPage.mensajes.actualizarInformacion")}
                    </p>
                  </Alert>
                </Col>
              </Row>
              <Row
                className="text-center"
                style={{ display: "flex", flexWrap: "wrap" }}
              >
                {ordenarTiposTramite(tiposTramites).map(
                  (tipo) =>
                    accionesPorTipo[tipo.codigo].filter(
                      (accion) => !accion.disabled,
                    ).length > 0 && (
                      <Col lg={6}>
                        <Grid>
                          <Row>
                            <Col>{ICONOS[tipo.codigo]}</Col>
                          </Row>
                          <Row>
                            <Col>
                              <Label>{tipo.nombre}</Label>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              <Grid>
                                <Row>
                                  <Col
                                    style={{
                                      height: "15ex",
                                      textAlign: "justify",
                                    }}
                                  >
                                    <p className="text-muted">
                                      {t(`usuarioPage.mensajes.${tipo.codigo}`)}
                                    </p>
                                  </Col>
                                </Row>
                                <Row>
                                  <Col style={{ minHeight: "36.5767px" }}>
                                    {accionesPorTipo[tipo.codigo].map(
                                      (accion) =>
                                        !accion.disabled && (
                                          <LinkButton
                                            sm
                                            variant={accion.variant}
                                            onClick={handleAccionClick(
                                              accion.name,
                                              tramitesPorTipo[tipo.codigo]
                                                ?.numero,
                                              tipo,
                                            )}
                                            // iconBefore={accion.icon}
                                            value={t(
                                              `usuarioPage.acciones.${accion.name}`,
                                            )}
                                          />
                                        ),
                                    )}
                                  </Col>
                                </Row>
                              </Grid>
                            </Col>
                          </Row>
                        </Grid>
                        <hr />
                      </Col>
                    ),
                )}
              </Row>
            </Grid>
          </Col>
        </Row>
      </Grid>
    </Loader>
  );
}
